/* Decottaa teması – katalog filtreleri ve sıralama (Section Rendering API ile, sayfa yenilemeden). */
(() => {
  const theme = window.theme || {};
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  /* Mağazanın para formatıyla, kuruşsuz gösterim (ör. "12.000 ₺") */
  const formatAmount = (amount) => {
    const format = theme.moneyFormat || '{{amount}}';
    const commaDecimal = /amount_with_comma_separator|amount_no_decimals_with_comma_separator/.test(format);
    const grouped = String(Math.round(amount)).replace(/\B(?=(\d{3})+(?!\d))/g, commaDecimal ? '.' : ',');
    return format.replace(/\{\{\s*\w+\s*\}\}/, grouped);
  };

  class ArchiveFilters extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form) return;
      this.timer = null;

      this.addEventListener('input', (event) => {
        const range = event.target.closest('[data-price-range]');
        if (!range) return;
        range.removeAttribute('data-untouched');
        const label = $('[data-price-label]', range.closest('.filter-field'));
        if (label) label.textContent = formatAmount(Number(range.value));
      });

      this.addEventListener('change', (event) => {
        const control = event.target;
        if (!control.form || control.form !== this.form) return;
        const wait = control.matches('[data-price-range]') ? 200 : 0;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.render(this.buildUrl(), true, control.id), wait);
      });

      this.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-sidebar-toggle]');
        if (toggle) {
          const sidebar = document.getElementById(toggle.getAttribute('aria-controls'));
          const open = !sidebar.classList.contains('open');
          sidebar.classList.toggle('open', open);
          toggle.setAttribute('aria-expanded', String(open));
          return;
        }
        const link = event.target.closest('[data-facet-link]');
        if (link && link.href) {
          event.preventDefault();
          this.render(link.href, true);
        }
      });

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.render(this.buildUrl(), true);
      });

      this.setupInfinite();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
    }

    /* Sayfa numaraları yerine: liste sonuna yaklaşınca sonraki sayfanın kartları aynı ızgaraya eklenir.
       "Daha fazla ürün" bağlantısı gerçek ?page= adresidir (JS'siz ziyaretçi ve arama motorları için). */
    setupInfinite() {
      const more = $('[data-infinite-more]', this);
      if (!more) return;
      more.addEventListener('click', (event) => {
        if (!event.target.closest('[data-infinite-link]') || !more.hasAttribute('data-infinite-more')) return;
        event.preventDefault();
        this.loadMore();
      });
      /* hızlı kaydırma / End tuşu düğmenin üstünden atlayabilir: düğme ekranın altına yaklaştıysa ya da geride kaldıysa yükle */
      if (!this.onScroll) {
        this.onScroll = () => {
          if (this.scrollQueued) return;
          this.scrollQueued = true;
          requestAnimationFrame(() => {
            this.scrollQueued = false;
            const target = $('[data-infinite-more]', this);
            if (target && target.getBoundingClientRect().top < window.innerHeight + 900) this.loadMore();
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
      }
      if (!('IntersectionObserver' in window)) return;
      if (!this.observer) {
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.loadMore();
        }, { rootMargin: '0px 0px 900px 0px' });
      }
      this.observer.observe(more);
    }

    async loadMore() {
      const more = $('[data-infinite-more]', this);
      const link = more && $('[data-infinite-link]', more);
      const grid = $('.archive-product-grid', this);
      if (this.loadingMore || !link || !grid) return;
      this.loadingMore = true;
      more.classList.add('is-loading');
      const status = $('[data-infinite-status]', more);
      if (status) status.textContent = more.dataset.loadingText || '';
      try {
        const requestUrl = new URL(link.href, window.location.origin);
        requestUrl.searchParams.set('section_id', this.sectionId);
        const response = await fetch(requestUrl.toString());
        if (!response.ok) throw new Error(response.status);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const freshGrid = $('.archive-product-grid', doc);
        if (!freshGrid) throw new Error('missing');
        grid.append(...Array.from(freshGrid.children).filter((card) => !card.matches('.archive-empty')));
        if (this.observer) this.observer.unobserve(more);
        const freshMore = $('[data-infinite-more]', doc);
        if (freshMore) {
          more.replaceWith(freshMore);
          this.setupInfinite();
        } else {
          more.remove();
        }
        const liveStatus = $('[data-infinite-status]', this) || status;
        if (liveStatus && freshMore) liveStatus.textContent = more.dataset.loadedText || '';
        document.dispatchEvent(new CustomEvent('theme:content'));
      } catch (error) {
        /* yüklenemezse bağlantı normal sayfa geçişi olarak çalışmaya devam eder */
        if (this.observer) this.observer.unobserve(more);
        more.classList.remove('is-loading');
        more.removeAttribute('data-infinite-more');
        if (status) status.textContent = '';
      } finally {
        this.loadingMore = false;
      }
    }

    buildUrl() {
      const params = new URLSearchParams();
      const range = $('[data-price-range]', this);
      new FormData(this.form).forEach((value, key) => {
        if (value === '') return;
        if (range && key === range.name && range.hasAttribute('data-untouched')) return;
        params.append(key, value);
      });
      const action = this.form.getAttribute('action') || window.location.pathname;
      const query = params.toString();
      return query ? `${action}?${query}` : action;
    }

    async render(url, push, focusId) {
      const sidebarOpen = $('[data-archive-sidebar]', this)?.classList.contains('open');
      this.classList.add('is-loading');
      try {
        const requestUrl = new URL(url, window.location.origin);
        requestUrl.searchParams.set('section_id', this.sectionId);
        const response = await fetch(requestUrl.toString());
        if (!response.ok) throw new Error(response.status);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = $('archive-filters', doc);
        if (!fresh) throw new Error('missing');
        if (sidebarOpen) {
          $('[data-archive-sidebar]', fresh)?.classList.add('open');
          $('[data-sidebar-toggle]', fresh)?.setAttribute('aria-expanded', 'true');
        }
        this.replaceWith(fresh);
        if (push) window.history.pushState({ archive: true }, '', url);
        const focusTarget = (focusId && document.getElementById(focusId)) || $('.archive-toolbar strong', fresh);
        if (focusTarget && focusTarget.focus) focusTarget.focus({ preventScroll: true });
        document.dispatchEvent(new CustomEvent('theme:content'));
      } catch (error) {
        window.location.href = url;
      }
    }
  }

  if (!customElements.get('archive-filters')) customElements.define('archive-filters', ArchiveFilters);

  window.addEventListener('popstate', () => {
    const filters = $('archive-filters');
    if (filters && typeof filters.render === 'function') filters.render(window.location.href, false);
  });

  /* Sıralama seçimi formun parçası olduğu için "change" ile yukarıdaki akışa girer. */
  theme.archiveReady = true;
})();
